import React from "react";

const STAFF = [
    {
        name: "VITOR 'TURBO' MENDES",
        role: "Dono / Fundador",
        tag: "WANTED · LVL.99",
        img: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
    },
    {
        name: "REBECA 'NIGHTRIDER' CRUZ",
        role: "Head Admin",
        tag: "WANTED · LVL.95",
        img: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
    },
    {
        name: "DIEGO 'KOMBI' SANTOS",
        role: "Dev / Mecânico",
        tag: "WANTED · LVL.88",
        img: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
    },
    {
        name: "LUANA 'ZN' COELHO",
        role: "Moderação",
        tag: "WANTED · LVL.80",
        img: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
    },
];

export default function Staff() {
    return (
        <section
            id="staff"
            data-testid="staff-section"
            className="relative py-24 md:py-40"
        >
            <div className="max-w-[1440px] mx-auto px-6 md:px-12">
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
                    <div>
                        <div className="flex items-center gap-3 mb-4">
                            <span className="h-px w-12 bg-neon-yellow" />
                            <span className="font-mono text-xs uppercase tracking-[0.3em] text-neon-yellow">
                                ▸ Procurados
                            </span>
                        </div>
                        <h2 className="font-heading text-5xl md:text-7xl uppercase tracking-tighter leading-none">
                            A Staff
                            <br />
                            <span className="text-neon-yellow">na mira</span>
                        </h2>
                    </div>
                    <p className="text-white/60 max-w-md text-base md:text-lg">
                        Quem mantém essa máquina rodando 24/7. Conhece o time
                        antes da próxima fuga.
                    </p>
                </div>

                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {STAFF.map((s, i) => (
                        <div
                            key={i}
                            data-testid={`staff-card-${i}`}
                            className="group relative bg-[#141414] border border-white/10 hover:border-neon-yellow transition-all"
                        >
                            <div className="relative aspect-[3/4] overflow-hidden bg-black">
                                <img
                                    src={s.img}
                                    alt={s.name}
                                    className="w-full h-full object-cover gallery-img"
                                />
                                <div className="absolute top-3 left-3 right-3 flex justify-between items-center font-mono text-[10px] uppercase tracking-[0.2em] text-neon-yellow">
                                    <span>{s.tag}</span>
                                    <span>0{i + 1}</span>
                                </div>
                                <div className="absolute bottom-0 inset-x-0 tape h-2" />
                            </div>
                            <div className="p-5">
                                <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-neon-yellow mb-1">
                                    {s.role}
                                </div>
                                <h3 className="font-heading text-2xl uppercase tracking-tight leading-tight">
                                    {s.name}
                                </h3>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
